import { render, staticRenderFns } from "./VideoUploader.vue?vue&type=template&id=c2fc163e&scoped=true&"
import script from "./VideoUploader.vue?vue&type=script&lang=js&"
export * from "./VideoUploader.vue?vue&type=script&lang=js&"
import style0 from "./VideoUploader.vue?vue&type=style&index=0&id=c2fc163e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fc163e",
  null
  
)

export default component.exports